import React from 'react'
import { Select } from 'semantic-ui-react'
import { environments } from '../../common/environment-configs'
import { useSelector, useDispatch } from 'react-redux'
import { changeEnvironment, selectEnvironment } from '../../features/environment/environmentSlice'

const getEnvironmentOptions = () => {
  const dict = []
  for (const e in environments) {
    dict.push({ key: e, value: environments[e], text: e })
  }
  return dict
}
const SelectEnvironment = () => {
  const environment = useSelector(selectEnvironment)
  const dispatch = useDispatch()
  return (
    <Select
      placeholder='Select environment'
      onChange={(event, data) => dispatch(changeEnvironment(data.value))}
      defaultValue={environment}
      options={getEnvironmentOptions()}
    />
  )
}

export default SelectEnvironment
